import { createFileRoute } from "@tanstack/react-router";
import { executeStateMachineRedirect } from "@/lib/routing/onboarding-redirect";
import { loadOnboardingStatusForContext } from "@/server/route-guard";

export const Route = createFileRoute("/")({
  beforeLoad: async ({ location }) => {
    const { onboardingStatus } = await loadOnboardingStatusForContext();
    executeStateMachineRedirect(onboardingStatus, location.pathname, "root.beforeLoad");
  },
  component: RootRedirectPage,
});

function RootRedirectPage() {
  return null;
}
